import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import PopUp from './PopUp'

/**
 * Shown instead of a device page when the device is outside of the user groups.
 */
const DeviceAccessDenied = ({ onHome, intl }) => {
  const { formatMessage } = intl

  const message = formatMessage({
    id: 'application.error.deviceAccessDenied',
    defaultMessage: 'You are not authorized to see this device. It belongs to a device group you are not a member of. Ask your account administrator to add you to this group.',
    description: 'Logged in user opening a device outside of their device groups',
  })

  const home = formatMessage({
    id: 'application.error.deviceAccessDenied.home',
    defaultMessage: 'Back to my devices',
    description: 'Button to go back to the home page from the device access message',
  })

  return (
    <PopUp
      text={message}
      visible
      textButton={home}
      functionButton={onHome}
      primaryButton
    />
  )
}

DeviceAccessDenied.propTypes = {
  onHome: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
}

export default injectIntl(DeviceAccessDenied)
